export default "__VITE_ASSET__C795oOoy__"